<template>
  <b-col v-if="!checkIsCordova">
    <a :href="fileSrc" style="text-decoration: none">
      <b-button
          data-test-path="download-button"
          variant="plm-primary-light"
          class="size-button"
          :disabled="disabled"
          @click.stop="clickOnButton"
      >
        <font-awesome-icon icon="download" />
        <label ref="label" class="d-none d-md-inline pl-1">{{$tr("download","Download")}}</label>
      </b-button>
    </a>
  </b-col>
  <b-col v-else>
    <b-button
        @click="downloadFile(fileSrc)"
        data-test-path="download-button"
        variant="plm-primary-light"
        class="size-button"
        :disabled="disabled"
    >
      <font-awesome-icon icon="download" />
      <label ref="label" class="d-none d-md-inline pl-1">{{$tr("download","Download")}}</label>
    </b-button>
  </b-col>
</template>

<script>


export default {
  name: "DownloadButton",

  computed: {
    checkIsCordova() {
      return window.isCordova;
    },
  },

  methods: {

    clickOnButton() {
      this.$emit("download");
    },

    async downloadFile(fileurl) {
      try {
        const blob = await this.downloadBlob(fileurl);
        if (!blob) {
          console.log("BLOB ERROR");
          return;
        }

        const filename = this.generateFileName();

        await this.writeFile(blob, filename);

        console.log("Plik został pomyślnie pobrany i zapisany.");
      } catch (error) {
        console.error("Wystąpił błąd podczas pobierania i zapisywania pliku.", error);
      }
    },

    downloadBlob(fileurl) {
      return new Promise((resolve, reject) => {
        const options = {
          method: "get",
          responseType: "blob",
        };

        cordova.plugin.http.sendRequest(
            fileurl,
            options,
            (response) => {
              console.log("cordova success", response);
              resolve(response.data);
            },
            (response) => {
              console.log("cordova error", response.error);
              reject(response.error);
            }
        );
      });
    },

    generateFileName() {
      const currentDate = new Date();

      const day = String(currentDate.getDate()).padStart(2, "0");
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const year = currentDate.getFullYear();

      const hours = String(currentDate.getHours()).padStart(2, "0");
      const minutes = String(currentDate.getMinutes()).padStart(2, "0");
      const seconds = String(currentDate.getSeconds()).padStart(2, "0");

      return `SilkPLM_${day}-${month}-${year}_${hours}-${minutes}-${seconds}.png`;
    },

    async writeFile(blob, filename) {
      return new Promise((resolve, reject) => {
        this.getDownloadDirectory()
            .then((downloadDir) => {
              downloadDir.getFile(
                  filename,
                  { create: true },
                  (file) => {
                    file.createWriter(
                        (fileWriter) => {
                          fileWriter.write(blob);

                          fileWriter.onwriteend = () => {
                            console.log(file);
                            resolve({ file, filename, fullPath: file.toURL() });
                          };

                          fileWriter.onerror = (err) => {
                            console.error("Wystąpił błąd podczas zapisywania pliku.", err);
                            reject(err);
                          };
                        },
                        (error) => {
                          console.error("Wystąpił błąd podczas tworzenia zapisywacza pliku.", error);
                          reject(error);
                        }
                    );
                  },
                  (error) => {
                    console.error("Wystąpił błąd podczas uzyskiwania dostępu do pliku.", error);
                    reject(error);
                  }
              );
            })
            .catch((error) => {
              console.error("Wystąpił błąd podczas uzyskiwania dostępu do katalogu Download.", error);
              reject(error);
            });
      });
    },

    getDownloadDirectory() {
      return new Promise((resolve, reject) => {
        window.resolveLocalFileSystemURL(cordova.file.externalRootDirectory, (rootDir) => {
          rootDir.getDirectory(
              "Download",
              { create: true },
              (downloadDir) => {
                resolve(downloadDir);
              },
              (error) => {
                reject(error);
              }
          );
        });
      });
    },
  },
  props: {
    fileSrc: { type: String, default: null },
    disabled: { type: Boolean, default: false },
  },
};
</script>